module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"favorMeasurement":"* favor these measurements when choosing the size."},"fr":{"favorMeasurement":"* privilégier ces mesure pour le choix de la taille."}}')
  delete Component.options._Ctor
}
